import {
  DefaultRevenueDeductType,
  EmployeeWelfareFundCalculationType,
  Locales,
  RevenueDeductOrderType,
  RevenueDeductType,
  SocialSecurityRevenueCalculationType,
  TableSorting,
  TaxRevenueCalculationType,
} from "@/enums/enums";
import { RevenueDeductModel } from "@/model/revenueDeduct/revenueDeductModel";

function GetCreateRevenueDeduct(revenueDeductType: RevenueDeductType = RevenueDeductType.Revenue) {
  return {
    id: 0,
    code: {
      value: "",
      validateError: false,
      isDisabled: false,
    },
    nameTh: {
      value: "",
      validateError: false,
      isDisabled: false,
    },
    nameEng: {
      value: "",
      validateError: false,
      isDisabled: false,
    },
    regularType: {
      value: 2,
      isDisabled: false,
    },
    revenueDeductType: revenueDeductType,
    taxRevenueCalculation: {
      taxRevenueCalculationType: {
        value: TaxRevenueCalculationType.IncludeIncomeType401,
      },
      isDisabled: false,
    },
    socialSecurityRevenueCalculation: {
      socialSecurityRevenueCalculationType: {
        value: SocialSecurityRevenueCalculationType.Include,
      },
      isDisabled: false,
    },
    employeeWelfareFundCalculation: {
      employeeWelfareFundCalculationType: {
        value: EmployeeWelfareFundCalculationType.Exclude,
      },
      isDisabled: false,
    },
    account: {
      data: {
        id: -1,
      },
      isDisabled: false,
    },
  };
}
export function GetCreateRevenueDeductTemplate(revenueDeductType: RevenueDeductType = RevenueDeductType.Revenue) {
  return GetCreateRevenueDeduct(revenueDeductType);
}
export function GetEditRevenueDeductTemplate(revenueDeductDetail: any) {
  const revenueDeductTemplate = GetCreateRevenueDeduct();

  if (revenueDeductDetail.id > 0) {
    revenueDeductTemplate.id = revenueDeductDetail.id;
    revenueDeductTemplate.code.value = revenueDeductDetail.code;
    revenueDeductTemplate.nameTh.value = revenueDeductDetail.nameTh;
    revenueDeductTemplate.nameEng.value = revenueDeductDetail.nameEn;
    revenueDeductTemplate.regularType.value = revenueDeductDetail.isRegular ? 1 : 2;
    revenueDeductTemplate.socialSecurityRevenueCalculation.socialSecurityRevenueCalculationType.value =
      revenueDeductDetail.socialSecurityRevenueCalculationType;
    revenueDeductTemplate.taxRevenueCalculation.taxRevenueCalculationType.value =
      revenueDeductDetail.taxRevenueCalculationType;
    revenueDeductTemplate.employeeWelfareFundCalculation.employeeWelfareFundCalculationType.value =
      revenueDeductDetail.employeeWelfareFundCalculationType;
    revenueDeductTemplate.account.data.id = revenueDeductDetail.accountId != null ? revenueDeductDetail.accountId : -1;
    revenueDeductTemplate.revenueDeductType = revenueDeductDetail.revenueDeductType;

    if (revenueDeductDetail.isMain) {
      revenueDeductTemplate.code.isDisabled = true;
      revenueDeductTemplate.nameEng.isDisabled = true;
      revenueDeductTemplate.nameTh.isDisabled = true;
      revenueDeductTemplate.regularType.isDisabled = true;
      revenueDeductTemplate.account.isDisabled = false;
      revenueDeductTemplate.taxRevenueCalculation.isDisabled = false;
      revenueDeductTemplate.socialSecurityRevenueCalculation.isDisabled = false;

      if (
        revenueDeductDetail.type === DefaultRevenueDeductType.EmployeeWelfareFund ||
        revenueDeductDetail.type === DefaultRevenueDeductType.Salary
      ) {
        revenueDeductTemplate.employeeWelfareFundCalculation.isDisabled = true;
      } else {
        revenueDeductTemplate.employeeWelfareFundCalculation.isDisabled = false;
      }
    }
  }

  return revenueDeductTemplate;
}
export function ValidateCreateRevenueDeduct(createRevenueDeductTemplate: any) {
  const codeValidateError = !createRevenueDeductTemplate.code.value || createRevenueDeductTemplate.code.validateError;
  const nameThValidateError =
    !createRevenueDeductTemplate.nameTh.value || createRevenueDeductTemplate.nameTh.validateError;
  const nameEngValidateError =
    !createRevenueDeductTemplate.nameEng.value || createRevenueDeductTemplate.nameEng.validateError;
  if (!codeValidateError && !nameThValidateError && !nameEngValidateError) {
    return true;
  } else {
    createRevenueDeductTemplate.code.validateError = codeValidateError;
    createRevenueDeductTemplate.nameTh.validateError = nameThValidateError;
    createRevenueDeductTemplate.nameEng.validateError = nameEngValidateError;
    return false;
  }
}
export function ConvertToRevenueDeductCreate(createRevenueDeductTemplate: any): RevenueDeductModel {
  const revenueDeductInsert: RevenueDeductModel = {
    id: 0,
    code: createRevenueDeductTemplate.code.value,
    nameTh: createRevenueDeductTemplate.nameTh.value,
    nameEn: createRevenueDeductTemplate.nameEng.value,
    accountId: createRevenueDeductTemplate.account.data.id == -1 ? null : createRevenueDeductTemplate.account.data.id,
    type: DefaultRevenueDeductType.Other,
    isMain: false,
    isArchived: false,
    revenueDeductType: createRevenueDeductTemplate.revenueDeductType,
    taxRevenueCalculationType: createRevenueDeductTemplate.taxRevenueCalculation.taxRevenueCalculationType.value,
    socialSecurityRevenueCalculationType:
      createRevenueDeductTemplate.socialSecurityRevenueCalculation.socialSecurityRevenueCalculationType.value,
    employeeWelfareFundCalculationType:
      createRevenueDeductTemplate.employeeWelfareFundCalculation.employeeWelfareFundCalculationType.value,
    isRegular: createRevenueDeductTemplate.regularType.value == 1,
  };
  return revenueDeductInsert;
}
export function ConvertToRevenueDeductEdit(createRevenueDeductTemplate: any): RevenueDeductModel {
  const revenueDeductInsert: RevenueDeductModel = {
    id: createRevenueDeductTemplate.id,
    code: createRevenueDeductTemplate.code.value,
    nameTh: createRevenueDeductTemplate.nameTh.value,
    nameEn: createRevenueDeductTemplate.nameEng.value,
    accountId: createRevenueDeductTemplate.account.data.id == -1 ? null : createRevenueDeductTemplate.account.data.id,
    type: DefaultRevenueDeductType.Other,
    isMain: false,
    isArchived: false,
    revenueDeductType: createRevenueDeductTemplate.revenueDeductType,
    taxRevenueCalculationType: createRevenueDeductTemplate.taxRevenueCalculation.taxRevenueCalculationType.value,
    socialSecurityRevenueCalculationType:
      createRevenueDeductTemplate.socialSecurityRevenueCalculation.socialSecurityRevenueCalculationType.value,
    employeeWelfareFundCalculationType:
      createRevenueDeductTemplate.employeeWelfareFundCalculation.employeeWelfareFundCalculationType.value,
    isRegular: createRevenueDeductTemplate.regularType.value == 1,
  };
  return revenueDeductInsert;
}

export function SetTableRevenueDeductList(tableViewModel: any, revenueDeductList: any) {
  let revenueDeductListFilter = revenueDeductList.filter(
    (x: any) => x.revenueDeductType === tableViewModel.tableStatus
  );
  revenueDeductListFilter = revenueDeductListFilter.sort((a: any, b: any) => (b.id > a.id ? 1 : -1));
  let dataSearchText = [];
  if (tableViewModel.searchText) {
    const searchText = revenueDeductListFilter.filter(
      (x: any) =>
        x.code.toLowerCase().includes(tableViewModel.searchText.toLowerCase()) ||
        x.nameEn.toLowerCase().includes(tableViewModel.searchText.toLowerCase()) ||
        x.nameTh.toLowerCase().includes(tableViewModel.searchText.toLowerCase())
    );
    if (searchText) {
      dataSearchText = searchText;
    }
  } else {
    dataSearchText = revenueDeductListFilter;
  }

  let dataSort = null;
  switch (tableViewModel.orderType) {
    case RevenueDeductOrderType.None:
      dataSort = dataSearchText;
      break;
    case RevenueDeductOrderType.Type:
      if (tableViewModel.sortingType == TableSorting.DESC) {
        dataSort = dataSearchText.sort((a: any, b: any) => (a.isRegular ? 1 : -1));
      } else {
        dataSort = dataSearchText.sort((a: any, b: any) => (a.isRegular ? -1 : 1));
      }
      break;
    case RevenueDeductOrderType.Code:
      if (tableViewModel.sortingType == TableSorting.DESC) {
        dataSort = dataSearchText.sort((a: any, b: any) => (b.code > a.code ? 1 : -1));
      } else {
        dataSort = dataSearchText.sort((a: any, b: any) => (a.code > b.code ? 1 : -1));
      }
      break;
    case RevenueDeductOrderType.Name:
      if (tableViewModel.sortingType == TableSorting.DESC) {
        dataSort = dataSearchText.sort((a: any, b: any) => (b.nameLocale > a.nameLocale ? 1 : -1));
      } else {
        dataSort = dataSearchText.sort((a: any, b: any) => (a.nameLocale > b.nameLocale ? 1 : -1));
      }
      break;
    case RevenueDeductOrderType.CalculateAnnualRevenue:
      if (tableViewModel.sortingType == TableSorting.DESC) {
        dataSort = dataSearchText.sort((a: any, b: any) =>
          b.taxRevenueCalculationType > a.taxRevenueCalculationType ? 1 : -1
        );
      } else {
        dataSort = dataSearchText.sort((a: any, b: any) =>
          a.taxRevenueCalculationType > b.taxRevenueCalculationType ? 1 : -1
        );
      }
      break;
    case RevenueDeductOrderType.Archived:
      if (tableViewModel.sortingType == TableSorting.DESC) {
        dataSort = dataSearchText.sort((a: any, b: any) => (b.isArchived ? 1 : -1));
      } else {
        dataSort = dataSearchText.sort((a: any, b: any) => (a.isArchived ? 1 : -1));
      }
      break;
  }

  const tableList = [];

  for (let i = 0; i < dataSort.length; i++) {
    if (i < tableViewModel.pageSize) {
      const index = tableViewModel.pageNo == 1 ? i : tableViewModel.pageSize * (tableViewModel.pageNo - 1) + i;
      if (index < dataSort.length) {
        tableList.push(dataSort[index]);
      }
    }
  }

  return {
    count: dataSort.length,
    tableList: tableList,
  };
}

export function SetTapsRevenueDeductTable(tableView: any, count: number) {
  const taps = [
    {
      name: "Revenue",
      length: 0,
      bgLengthColor: "gray",
      showtableCount: false,
      tableViewStatusType: 0,
      active: false,
    },
    {
      name: "Deduct",
      length: 0,
      bgLengthColor: "gray",
      showtableCount: false,
      tableViewStatusType: 1,
      active: false,
    },
  ];
  taps.forEach((item) => {
    if (item.tableViewStatusType === tableView.tableStatus) {
      item.length = count;
      item.active = true;
    }
  });

  return taps;
}

export function SetHeaderRevenueDeductTable(tableViewModel: any) {
  const header = [
    {
      name: "check",
      hidden: true,
      checkAll: false,
    },

    {
      name: "Code",
      sortBy: RevenueDeductOrderType.Code,
      sortingType: null,
      width: 50,
      align: "flex-start",
    },
    {
      name: "Name_Item",
      sortBy: RevenueDeductOrderType.Name,
      sortingType: null,
      width: 220,
      align: "flex-start",
    },
    {
      name: "Account_to_be_recorded",
      sortBy: null,
      sortingType: null,
      width: 150,
      align: "flex-start",
    },
    {
      name: "Type",
      sortBy: RevenueDeductOrderType.Type,
      sortingType: null,
      width: 60,
      align: "flex-start",
    },
    {
      name: "Calculate_annual_revenue",
      sortBy: RevenueDeductOrderType.CalculateAnnualRevenue,
      sortingType: null,
      width: 180,
      align: "flex-start",
    },
    {
      name: "Ready_to_use",
      sortBy: RevenueDeductOrderType.Archived,
      sortingType: null,
      width: 100,
      align: "flex-start",
    },
    {
      name: "",
      sortBy: null,
      sortingType: null,
      width: 5,
      align: "flex-start",
    },
  ];

  header.forEach((item) => {
    if (item.sortBy === tableViewModel.orderType) {
      item.sortingType = tableViewModel.sortingType;
    } else {
      item.sortingType = null;
    }
  });

  return header;
}

export function UpdateRevenueDeductNameLocale(revenueDeductList: any, lang: string) {
  revenueDeductList.forEach((revenueDeduct: any) => {
    revenueDeduct.nameLocale = lang === Locales.TH ? revenueDeduct.nameTh : revenueDeduct.nameEn;
  });
}
